import React, { Component } from "react";
import View from "./view";
import "./index.css";
import { getUser, getToken } from "../../backend/storage";
import {assignTool, getTool} from "../../backend/tool";
import {getRequestList, searchTool} from "../../backend/machine";

class ToolScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToLogin: false,
      code: props.match.params.barcode || "",
      showDialog: false,
      receiveSuccess: false,
      toolRequestClick: false,
      loading: false,
      tool : { id: "", code:""},
      errMsg: "",
      request_list:[],
      courier_number: "",
      courier_number2: "",
      branchRecordId: "",
      machine_model : [], // store 허용 machine
      storeId : "",
      storeName : "",
      toolId: "",
      toolCode: "",
      bag_id : "",
      checkModelPop: false,
      checkModelPopMsg:"",
      checkModelContinue : false,
    };

    this._getTool = this._getTool.bind(this);
    this._searchTool = this._searchTool.bind(this)
    this._assignTool = this._assignTool.bind(this);
    this._checkToolStatus = this._checkToolStatus.bind(this);
    this._renderRequestListMainTool = this._renderRequestListMainTool.bind(this);
  }

  async componentDidMount() {
    if (!(await getUser()) || !(await getToken())) {
      this.setState({ redirectToLogin: true });
    }

    if (this.state.code !== "") {
      this._getTool(this.state.code);
    }

    // get Request List
    let request_list_response = await getRequestList('Tool');
    this.setState({request_list : request_list_response})
  }


  async _assignTool() {
    this.setState({ loading: true });
    assignTool(this.state.tool.id);
    this.setState({ receiveSuccess: true, loading: false });
  }

  async _searchTool(code) {
    let result = await searchTool(code);
    return result.data.map(tool => ({value: tool.id, label: tool.code, bag_id: tool.bag_id}));
  }

  async _getTool() {
    const { history } = this.props;

    this.setState({ loading: true, errMsg: "" });

    let tool;

    try {
      tool = await getTool(this.state.code);
      if (tool.success === 1) {
        this.setState({
          tool: tool.data,
          loading: false
        });
      } else {
        this.setState({
          tool: { id: "" },
          loading: false,
          errMsg: tool.data
        });
      }
    } catch (error) {
      if (error.message === "token_not_provided") return history.push("/login");
    }
  }

  render() {
    return View.call(this);
  }
  // Only Available status machine can be sent
  _checkToolStatus(){
    let status = this.state.tool.hire_status
    if(status !== 'Available'){
      this.setState({errMsg : "This machine cannot be sent to the store. Please check a machine status."})
    }else{
      // redirect to the form
      this.props.history.push({
        pathname: `/tool/${this.state.tool.id}/send`
      })
    }
  }
  _renderRequestListMainTool( item, key ){
    return ( item.type === 'Tool' &&
        <a className="request_list_item" key={key} data-id={item.id}>
          <strong>{item.store.name}</strong>
          <div className="flex_wrap">
            <div>
              Outgoing : <b>{item.courier_number}</b><br />
              Incoming : <b>{item.courier_number2}</b>
            </div>
          </div>
        </a>
    )

    /*return ( item.type === 'Tool' &&
      <a className="request_list_item" key={key} data-id={item.id} onClick={ () =>{
        this.setState({
          courier_number: item.courier_number,
          courier_number2 : item.courier_number2,
          branchRecordId: item.id,
          storeId : item.store.id,
          storeName : item.store.name,
        },() =>{
          // tool search popup 띄워야 함.
          this.setState({
            toolRequestClick: true,
          })
        })

      }

      }>
        <strong>{item.store.name}</strong>
        <div className="flex_wrap">
          <div>
            Outgoing : <b>{item.courier_number}</b><br />
            Incoming : <b>{item.courier_number2}</b>
          </div>
        </div>
      </a>
    )*/
  }
}

export default ToolScreen;


// WEBPACK FOOTER //
// ./src/screens/tool/index.js